import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar"]
  static values = { selectedActivityId: Number }

  selectActivity(event) {
    const activityId = event.currentTarget.dataset.activityId
    this.selectedActivityIdValue = Number.parseInt(activityId, 10)

    if (event.currentTarget.dataset.activityHasOutcomes === "true") {
      document.getElementById(`section-activity-${activityId}`)?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      })
    }

    if (window.innerWidth < 1024) this.closeSidebar()
  }

  openSidebar() {
    if (!this.hasSidebarTarget) return

    this.sidebarTarget.classList.remove("hidden")
    this.sidebarTarget.classList.add("flex")
  }

  closeSidebar() {
    if (!this.hasSidebarTarget) return

    this.sidebarTarget.classList.remove("flex")
    this.sidebarTarget.classList.add("hidden", "lg:flex")
  }
}
